import {
    ENVIRONMENT_INITIALIZER,
    EnvironmentProviders,
    InjectionToken,
    Provider,
    inject,
    provideZoneChangeDetection,
} from '@angular/core';
import { LoadingService } from './shared/services/loading.service';
import { LoadingInterceptor } from './shared/interceptors/loading.interceptor';
import {
    provideHttpClient,
    withInterceptors,
    withInterceptorsFromDi,
} from '@angular/common/http';
import { ErrorInterceptor } from './shared/interceptors/error.interceptor';
import { provideToastr } from 'ngx-toastr';
import { APP_BASE_HREF, PlatformLocation } from '@angular/common';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { routes } from './app.routes';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MAT_TABS_CONFIG } from '@angular/material/tabs';
import { ApplicationConfigurationService } from './core/services/ApplicationConfiguration.service';
import { authTokenInterceptor } from './core/auth.interceptor';
import { provideMarkdown } from "ngx-markdown";
import { provideDateConfiguration } from './shared/config/date-module.providers';
export const APP_CONFIG = new InjectionToken<ApplicationConfigurationService>(
    'APP_CONFIG',
);

export function getBaseHref(platformLocation: PlatformLocation): string {
    return platformLocation.getBaseHrefFromDOM();
}

export const provideBits = (): Array<Provider | EnvironmentProviders> => {
    const providers: Array<Provider | EnvironmentProviders> = [
        provideZoneChangeDetection({ eventCoalescing: true }),

        // Use provideRouter to bind route data to component inputs
        provideRouter(routes, withComponentInputBinding()),
        //provideAnimationsAsync(),
        provideCharts(withDefaultRegisterables()),
        provideHttpClient(
            withInterceptorsFromDi(),
            withInterceptors([
                authTokenInterceptor,
                LoadingInterceptor,
                ErrorInterceptor,
            ]),
        ),
        {
            provide: ENVIRONMENT_INITIALIZER,
            useValue: () => inject(LoadingService),
            multi: true,
        },

        provideMarkdown(),  // For now, we are using defaults. If necessary, you can add options here.

        provideToastr({
            positionClass: 'toast-top-left',
            preventDuplicates: true,
        }),
        {
            provide: APP_BASE_HREF,
            useFactory: getBaseHref,
            deps: [PlatformLocation],
        },
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: {
                subscriptSizing: 'fixed',  // GH changed so all inputs will always have the space allocated - no shift if errors/etc. are displayed. Also, no need for margin-bottom.
            },
        },
        {
            provide: MAT_TABS_CONFIG, // Provide global configuration for mat-tab-group
            useValue: {
                stretchTabs: false,
            },
        },

        // Date Providers Configuration - default to native adapter so Material date pickers work everywhere.
        ...provideDateConfiguration('en-US', 'native'),
    ];

    return providers;
};
